const CURRENTACTIVE_PROJECTID_KEY = 'currentactive_projectid';
const CURRENTACTIVE_CONTRACTKEY_KEY = 'currentactive_contractkey';    // opportunity

/**
 * Sets the CURRENT ACTIVE ProjectId
 */
export function setCurrentActiveProjectId(projectId) {
    localStorage.setItem(CURRENTACTIVE_PROJECTID_KEY, projectId);
}

/**
 * Returns the CURRENT ACTIVE ProjectId
 */
export function getCurrentActiveProjectId() {
    const value = localStorage.getItem(CURRENTACTIVE_PROJECTID_KEY);
    return value ? parseInt(value) : null;
}

/**
 * Clears the CURRENT ACTIVE ProjectId  
 */
export function clearCurrentActiveProjectId() {
    localStorage.removeItem(CURRENTACTIVE_PROJECTID_KEY);
}



/**
 * Sets the CURRENT ACTIVE ContractKey (opportunity)
 */
export function setCurrentActiveContractKey(contractKey) {
    localStorage.setItem(CURRENTACTIVE_CONTRACTKEY_KEY, contractKey);
}

/**
 * Returns the CURRENT ACTIVE ContractKey (opportunity)
 */
export function getCurrentActiveContractKey() {
    const value = localStorage.getItem(CURRENTACTIVE_CONTRACTKEY_KEY);
    return value ? parseInt(value) : null;
}

/**
 * Clears the CURRENT ACTIVE ContracttKey (opportunity)  
 */
export function clearCurrentActiveContractKey() {
    localStorage.removeItem(CURRENTACTIVE_CONTRACTKEY_KEY);
}